import { Auth } from 'aws-amplify'
import { setupCache } from 'axios-cache-interceptor'
import { AxiosRetryFactory } from '../lib/helpers/axios-retry-factory'

export default ({ $axios, $sentry, store }, inject) => {
  // axios-cache-interceptor npm source: https://www.npmjs.com/package/axios-cache-interceptor
  const headerInterpreter = headers => {
    if (headers['cache-control']) {
      const cacheControl = headers['cache-control']
      const regex = /max-age=(\d+)/
      const match = cacheControl.match(regex)
      const ttl = match ? match[1] : null

      if (ttl) return ttl

      return 'not enough headers' // The request will find other ways to determine the TTL value.
    }

    return 1000 // 1 second
  }

  let api = $axios.create({
    baseURL: process.env.API_BASE,
  })

  if (store.state.flags.enable_api_deduplication) {
    // Create a new instance of Axios with caching enabled
    api = setupCache(api, {
      headerInterpreter,
    })
  }

  AxiosRetryFactory(api)

  api.interceptors.request.use(async config => {
    if (!config.url || config.url.indexOf('http') === 0) return config

    const session = await Auth.currentSession().catch(() => null)

    if (session) {
      const accessToken = session.getAccessToken()
      config.headers.common['Authorization'] = `Bearer ${accessToken.jwtToken}`
    }

    return config
  })

  const onError = error => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (error.response.status >= 500) {
        $sentry.captureException(error)
      }

      error.message = error.response.data.message || 'Something went wrong.'

      throw error
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      $sentry.captureException(error)
      throw error
    } else {
      // Something happened in setting up the request that triggered an Error
      $sentry.captureException(error)
      throw error
    }
  }

  api.interceptors.request.use(undefined, onError)
  api.interceptors.response.use(undefined, onError)

  inject('api', api)
}
